import { Avatar, Breadcrumb, Button, Dropdown, Image } from "antd";
import {
  AngleRight,
  DeleteIcon,
  PlusIcon,
} from "../../../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";

interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface HeaderProps {
  title: string;
  description?: string | React.ReactNode;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  btnText2?: string;
  breadcrumb?: BreadcrumbItem[];
  imageIcon?: string;
  avatarColor?: string;
  avatarIcon?: React.ReactNode;
  propertyName: string;
  propertyClientName: string;
}

export default function DashboardHeader({
  title,
  description,
  btnText1,
  btnIcon1,
  btnText2,
  breadcrumb = [],
  imageIcon,
  avatarIcon,
  avatarColor,
  propertyName,
  propertyClientName,
}: HeaderProps) {
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<PlusIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Add property
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Archive
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div className="profileHeader">
      <div className="headerLeft">
        {breadcrumb.length > 0 && (
          <Breadcrumb
            separator={<AngleRight />}
            style={{ marginBottom: "12px" }}
          >
            <Breadcrumb.Item>
              <a href={`/contracts/${companyId}`}> Contracts </a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Contract details</Breadcrumb.Item>
          </Breadcrumb>
        )}
        {imageIcon || avatarIcon ? (
          <div className="headerContentWithImage">
            {imageIcon && <Image src={imageIcon} preview={false} />}
            {avatarIcon && (
              <Avatar
                size={58}
                className={avatarColor}
                shape="square"
                src={avatarIcon}
              />
            )}
            <div>
              <h2>{title}</h2>
              {description && <p>{description}</p>}
            </div>
          </div>
        ) : (
          <>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  color: "#6454F4",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginRight: "8px",
                }}
              >
                <img src="/images/estimate/building-icon.svg" alt="" />
                {propertyName}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  color: "#474C4D",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <img src="/images/estimate/clients-icon.svg" alt="" />
                {propertyClientName}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="headerRight" style={{ marginTop: 15 }}>
        <Button
          htmlType="button"
          type="default"
          size="large"
          className="mint-btn"
          style={{ marginRight: "8px" }}
        >
          Active
        </Button>
        <Button
          htmlType="button"
          type="default"
          size="large"
          className="outlined-btn"
          style={{ marginRight: "8px" }}
        >
          Notes & activity
        </Button>

        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(x) => {
              x.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "0px",
              height: "36px",
              width: "36px",
              backgroundColor: "transparent",
              border: "1px solid #DEE5E6",
              borderRadius: "8px",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      </div>

      {(btnText1 || btnText2) && (
        <div className="two_btns">
          {btnText1 && (
            <Button htmlType="submit" size="large" className="btn-sm">
              {btnIcon1 && btnIcon1} {btnText1}
            </Button>
          )}
          {btnText2 && (
            <Button htmlType="submit" size="large" className="outlined-btn">
              {btnText2}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
